import React, { useState } from 'react';
import { Box, VStack, HStack, Heading, Text, Button } from '@chakra-ui/react';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp
} from 'react-icons/md';
import DetailsTable from '@components/DetailsTable';
import { clientSettlementsConfig as config } from '@views/SettlementServiceDashboard/utils';

const ClientAccounts = ({ selectedClient, setSelectedClient }) => {
  const [isClientSettlementCollapsed, setIsClientSettlementCollapsed] =
    useState(false);
  const [isClientAccountCollapsed, setIsClientAccountCollapsed] =
    useState(false);

  const clientSettlementObj = config.getClientSettlementTable(selectedClient);

  return (
    <Box position="relative" width="100%">
      <VStack
        overflowY={{ base: 'initial', lg: 'scroll' }}
        overflowX="hidden"
        alignItems="stretch"
        gap={4}
      >
        {/* Client Details */}
        <VStack
          w={'100%'}
          alignSelf={'start'}
          alignItems={'stretch'}
          justifyContent={'space-between'}
          border={'1px solid'}
          borderColor={'whiteAlpha.300'}
          bg={'backGround'}
          borderRadius={'xl'}
          p={4}
        >
          <HStack justifyContent="space-between">
            <Heading fontSize="lg" color="brand.500">
              Client Details
            </Heading>
            <Button
              size="sm"
              bg="black"
              border={'1px solid'}
              borderColor={'whiteAlpha.300'}
              borderRadius={'xl'}
              onClick={() =>
                setIsClientSettlementCollapsed(!isClientSettlementCollapsed)
              }
              p={0}
              variant={'subtle'}
            >
              {isClientSettlementCollapsed ? (
                <MdOutlineKeyboardArrowDown size={'1.25rem'} />
              ) : (
                <MdOutlineKeyboardArrowUp size={'1.25rem'} />
              )}
            </Button>
          </HStack>
          {!isClientSettlementCollapsed && (
            <VStack
              w="100%"
              alignSelf="start"
              alignItems="stretch"
              justifyContent="space-between"
              border="1px solid"
              borderColor="whiteAlpha.300"
              borderRadius="xl"
              bg="blackAlpha.600"
              px={4}
              py={2}
            >
              {clientSettlementObj.map(
                (item, index) =>
                  item.data && (
                    <DetailsTable
                      key={index}
                      details={item.data}
                      rowGap={'1rem'}
                      marginTop="0"
                      isSidebar={'true'}
                    />
                  )
              )}
            </VStack>
          )}
        </VStack>

        <VStack
          w={'100%'}
          alignSelf={'start'}
          alignItems={'stretch'}
          justifyContent={'space-between'}
          border={'1px solid'}
          borderColor={'whiteAlpha.300'}
          bg={'backGround'}
          borderRadius={'xl'}
          p={4}
        >
          <HStack justifyContent="space-between">
            <Heading fontSize="lg" color="brand.500">
              Client Account Details
            </Heading>
            <HStack justifyContent="space-between" gap={2}>
              {selectedClient?.account?.length > 0 && (
                <Text fontSize={'xs'} color="brand.500">
                  Avlbl Client Account: {selectedClient?.account?.length}
                </Text>
              )}
              <Button
                size="sm"
                bg={'blackAlpha.600'}
                border={'1px solid'}
                borderColor={'whiteAlpha.300'}
                borderRadius={'xl'}
                onClick={() =>
                  setIsClientAccountCollapsed(!isClientAccountCollapsed)
                }
                p={0}
                variant={'subtle'}
              >
                {isClientAccountCollapsed ? (
                  <MdOutlineKeyboardArrowDown size={'1.25rem'} />
                ) : (
                  <MdOutlineKeyboardArrowUp size={'1.25rem'} />
                )}
              </Button>
            </HStack>
          </HStack>
          {!isClientAccountCollapsed && (
            <VStack
              overflowY="auto" // Make the area scrollable
              width="100%" // Ensure consistent width
              spacing={4} // Add spacing between payout items
            >
              {selectedClient?.accounts.length > 0 ? (
                selectedClient?.accounts.map((accountItem, index) => {
                  const clientAccountObj =
                    config.getClientAccountTable(accountItem);
                  return (
                    <VStack
                      key={index}
                      w={'100%'}
                      alignSelf={'start'}
                      alignItems={'stretch'}
                      justifyContent={'space-between'}
                      border={'1px solid'}
                      borderColor={'whiteAlpha.300'}
                      borderRadius={'xl'}
                      bg={'blackAlpha.600'}
                      px={4}
                      py={2}
                    >
                      {clientAccountObj.map((item) => (
                        <DetailsTable
                          isSidebar={true}
                          details={item.data}
                          rowGap={'1rem'}
                          marginTop={'0'}
                        />
                      ))}
                    </VStack>
                  );
                })
              ) : (
                <HStack
                  w={'100%'}
                  alignSelf={'start'}
                  justifyContent={'center'}
                  border={'1px solid'}
                  borderColor={'whiteAlpha.300'}
                  bg={'blackAlpha.600'}
                  borderRadius="12px"
                  p={4}
                >
                  <Text color={'whiteAlpha.800'}>
                    No Client Accounts Available
                  </Text>
                </HStack>
              )}
            </VStack>
          )}
        </VStack>
      </VStack>
    </Box>
  );
};

export default ClientAccounts;
